var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"},on:{"click":_vm.close}},[_c('v-overlay',{attrs:{"absolute":true,"z-index":"9999"}},[_c('v-card',[_c('v-img',{attrs:{"width":"1024","src":_vm.src}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }